import { render } from "./PersonOutlineIcon.vue?vue&type=template&id=b79c5ac0"
import script from "./PersonOutlineIcon.vue?vue&type=script&lang=js"
export * from "./PersonOutlineIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__